import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Toaster } from '@app/services';
import {
  FinancialReportColumnInputPayload,
  FinancialReportInputPayload,
  FinancialReportTypeInputPayload,
  LasgroFinancial_report_type,
} from 'api/models';
import { FinancialReportColumnService, FinancialReportTypeService } from 'api/services';
import CustomStore from 'devextreme/data/custom_store';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import * as moment from 'moment';

@Component({
  selector: 'financial-report-type',
  templateUrl: './financial-report-type.modal.html',
  styleUrls: ['./financial-report-type.modal.scss'],
})
export class FinancialReportTypeModal implements OnInit {
  @Input() modal: MatDialogRef<FinancialReportTypeModal>;
  @Input() financialReportType = {};
  selectedRaw: FinancialReportTypeInputPayload = {
    financialReportColumns: [],
  } as FinancialReportTypeInputPayload;
  dataSource: any;
  newColumnName: string;
  constructor(
    private financialReportTypeServcie: FinancialReportTypeService,
    private toaster: Toaster,
    private financialReportColumnService: FinancialReportColumnService,
  ) {}

  ngOnInit(): void {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => this.initUnits(),
      insert: (value) => this.addUnit(value),
      remove: (key) => this.deleteUnit(key),
    });
  }

  initUnits() {
    return this.financialReportTypeServcie
      .financialReportTypeList()
      .toPromise()
      .then((types: any) => types)
      .catch((error) => {
        console.error(error);
        this.toaster.show('error', 'Users', 'An error occurred, please try again later.');
      });
  }

  addUnit(data: any) {
    return this.financialReportTypeServcie
      .financialReportTypeAdd({ name: data.name })
      .toPromise()
      .then(
        (response: any) => {
          this.selectedRaw.id = response;
          this.toaster.show('success', '', `Type was added successfully`);
        },
        (error) => {
          console.error(error);
          this.toaster.show('error', 'Error', 'An error occurred, please try again later.');
        },
      );
  }

  updateType(data: any) {
    return this.financialReportTypeServcie.financialReportTypeUpdate(data).subscribe(
      (response: any) => {
        this.toaster.show('success', '', `Type was updated successfully`);
      },
      (error) => {
        console.error(error);
        this.toaster.show('error', 'Error', "You can't modify connected type");
      },
    );
  }

  saveUnit(data: any) {
    if (this.selectedRaw.id) {
      this.updateType(data);
    } else {
      this.addUnit(data);
    }
  }

  deleteUnit(id: any) {
    return this.financialReportTypeServcie
      .financialReportTypeDelete(id)
      .toPromise()
      .then(
        (response: any) => {
          this.toaster.show('success', '', `Type was deleted successfully`);
        },
        (error) => {
          console.error(error);
          this.toaster.show('error', 'Error', "You can't remove connected type");
        },
      );
  }

  canEdit() {
    return true;
  }

  closeModal() {
    this.modal.close();
  }

  onSelectionChanged(data) {
    if (!data.financialReportColumns) {
      data.financialReportColumns = [];
    }
    if (data.financialReportType) {
      data.financialReportType.financialReportColumns = data.financialReportType.financialReportColumns.sort((a, b) => {
        return a.order - b.order;
      });
    }
    this.selectedRaw = data;
  }

  addColumn() {
    if (!this.selectedRaw.financialReportColumns) {
      this.selectedRaw.financialReportColumns = [];
    }
    if (!this.newColumnName) {
      this.toaster.show('error', '', "Column name can't be empty");
      return;
    }
    this.selectedRaw.financialReportColumns.push({
      name: this.newColumnName,
      financialReportTypeID: this.selectedRaw.id,
      order: this.selectedRaw.financialReportColumns.length + 1,
      endDate: moment().toJSON(),
    });
    this.newColumnName = '';
    this.updateType(this.selectedRaw);
  }

  removeColumn(col) {
    let index = this.selectedRaw.financialReportColumns.indexOf(col);
    this.selectedRaw.financialReportColumns = this.selectedRaw.financialReportColumns.splice(index, 1);
    this.updateType(this.selectedRaw);
  }

  drop(event: CdkDragDrop<FinancialReportColumnInputPayload[]>) {
    moveItemInArray(this.selectedRaw.financialReportColumns, event.previousIndex, event.currentIndex);

    // Update order property based on new positions
    this.selectedRaw.financialReportColumns.forEach((item: FinancialReportColumnInputPayload, index) => {
      item.order = index + 1; // Assuming order starts from 1
    });
    this.updateType(this.selectedRaw);
  }

  updateDate(item) {
    if (item.endDate) {
      this.financialReportColumnService.financialReportColumnUpdate(item).subscribe(() => {
        this.toaster.show('success', '', 'Data saved succesfuly');
      });
    }
  }
}
